var swiper = new Swiper(".topHeader", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    autoplay: {
        delay: 3000, 
        disableOnInteraction: false, 
    },
    navigation: {
        nextEl: ".proj-arrow-next",
        prevEl: ".proj-arrow-prev",
    },
    speed: 1500,
});

// BACK TO TOP

var backtop = jQuery('#backtop');

jQuery(window).scroll(function() {
  if (jQuery(window).scrollTop() > 300) {
    backtop.addClass('show');
  } else {
    backtop.removeClass('show');
  }
});

backtop.on('click', function(e) {
  e.preventDefault();
  jQuery('html, body').animate({scrollTop: 0}, '300');
});

// RESPONSIVE MENU ENTRY JS

jQuery('.head-icon a').click(function(){
	jQuery('.responsive-menu').addClass('active');
    jQuery('body').addClass('stop-scroll');
});

// RESPONSIVE MENU EXIT JS

jQuery('.respon-cross a').click(function(){
	jQuery('.responsive-menu').removeClass('active');
    jQuery('body').removeClass('stop-scroll');
});

// RESPONSIVE MENU UL TOGGLE JS

jQuery(document).ready(function () {
    jQuery('.responsive-links ul li > a').click(function (e) {
        if (jQuery(this).siblings('ul').length > 0) {
            e.preventDefault();
            e.stopPropagation();
            
            jQuery('.responsive-links ul li > a').not(this).siblings('ul').slideUp();
            jQuery('.responsive-links ul li > a').not(this).parent().removeClass('active');

            jQuery(this).siblings('ul').slideToggle();
            jQuery(this).parent().toggleClass('active');
        }
    });
});

AOS.init({
  once: true,
  mobile:false,
});